<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

:root {
  --brand-50: #f8fafc;
  --brand-100: #f1f5f9;
  --brand-200: #e2e8f0;
  --brand-300: #cbd5e1;
  --brand-400: #94a3b8;
  --brand-500: #64748b;
  --brand-600: #475569;
  --brand-700: #334155;
  --brand-800: #1e293b;
  --brand-900: #0f172a;
  --primary: #3b82f6;
  --success: #22c55e;
  --warning: #f59e0b;
  --danger: #ef4444;
}

* {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  overflow: hidden;
}
body {
  margin: 0;
  padding: 0;
  background-color: var(--brand-50);
  color: var(--brand-800);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#app {
  height: 100%;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: #f1f5f9;
}
::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Element UI overrides */
.el-button--primary {
  background: linear-gradient(to right, #3b82f6, #2563eb) !important;
  border-color: #3b82f6 !important;
  border-radius: 10px !important;
}
.el-button--primary:hover {
  background: linear-gradient(to right, #2563eb, #1d4ed8) !important;
  border-color: #2563eb !important;
}
.el-button {
  border-radius: 10px !important;
}
.el-input__inner {
  border-radius: 10px !important;
  border-color: var(--brand-200) !important;
}
.el-input__inner:focus {
  border-color: var(--primary) !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
}
.el-select .el-input__inner {
  border-radius: 10px !important;
}
.el-table {
  border-radius: 0 !important;
}
.el-table th {
  background-color: var(--brand-50) !important;
  color: var(--brand-500) !important;
  font-weight: 500 !important;
}
.el-table td {
  color: var(--brand-600) !important;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: var(--brand-50) !important;
}
.el-dialog {
  border-radius: 16px !important;
}
.el-dialog__header {
  border-bottom: 1px solid var(--brand-100) !important;
  padding: 20px 24px !important;
}
.el-dialog__body {
  padding: 24px !important;
}
.el-dialog__footer {
  border-top: 1px solid var(--brand-100) !important;
  padding: 16px 24px !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: var(--primary) !important;
}
.el-tag {
  border-radius: 20px !important;
}
</style>
